import { Component, Input, OnInit } from '@angular/core';
import { IBreadcrumb } from './breadcrumbs.interface';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
  @Input() path: string = '';
  @Input() mt_0: boolean = false;
  @Input() title: string = '';

  breadcrumbs: IBreadcrumb[] = [];

  constructor() {

  }


  ngOnInit(): void {
    this.breadcrumbs = this.path.split('/').filter((item: string) => item !== '').map((item: string) => {
      // this.title = this.title.replace(/[^a-zA-Z0-9 ]/g, '');
      if (this.title.length > 0) {
        this.title = this.title.charAt(0).toUpperCase() + this.title.slice(1);
      }
      return {
        url: this.path.split(item)[0] + item,
        title: item[0].toUpperCase() + item.slice(1).replace(/-/g, ' '),
      }
    });
  }
}